($ => {
  $('.dropdown-submenu-toggle').click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $('.dropdown-submenu').removeClass('show').attr('aria-expanded', 'false');
    $(this).parent().addClass('show').attr('aria-expanded', 'true');
  });
})(jQuery);
